<template>
  <v-application>
    <v-layout row class="ma-2">
      <v-flex md8>
        <v-crud-card
          name="task"
          to="/employees/task"
          v-bind:headers="headers"
          v-bind:data="all_tasks"
          v-bind:row="typing_task"
          v-bind:num-pages="total"
          v-model="page"
          v-bind:add_button_name="'add_task'"
          @change-pagination="changePagination"
          no-delete
        ></v-crud-card>
      </v-flex>
    </v-layout>
  </v-application>

</template>
<script>
import Task from "../../mixins/employees/task";
export default {
  name: "Task",
  mixins: [Task],
  data: () => ({
    headers: [
      { text: "Title", value: "title", align: "left" },
      { text: "Unit name", value: "unit_name" },
    ],
    total: 1,
    page: 1,
    tasks: [],
    all_tasks: []
  }),
  methods: {
    changePagination(page) {
      this.page = page;
    },
    save() {},
    typing_task() {},
  },
  mounted() {
    this.headers = [
      { text: this.$t("title"), value: "title", align: "left",available: true },
      { text: this.$t("unit_name"), value: "unit_name", align: 'right' , available: true},
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
    this.getTasks()
  },
};
</script>
